module.exports = __webpack_public_path__ + "img/bags.744587b6.png";